<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="1">
                </v-col>
                <v-col cols="12" md="5" class="px-10">
                    <h1 class="mb-5">Every Channel, One Platform</h1>
                    <div>
                        From a single interface, you can:

                        <v-list>
                            <v-list-item class="mb-3">
                                <v-icon color="green" class="mr-2">mdi-check-circle</v-icon> Send SMS, MMS, Voice, and Email messages at scale.
                            </v-list-item>
                            <v-list-item class="mb-3">
                                <v-icon color="green" class="mr-2">mdi-check-circle</v-icon> Target the right audience with filtered contact lists.  
                            </v-list-item>
                            <v-list-item class="mb-3">
                                <v-icon color="green" class="mr-2">mdi-check-circle</v-icon> Switch seamlessly between one-way broadcasts and two-way conversations. 
                            </v-list-item>
                            <v-list-item class="mb-3">
                                <v-icon color="green" class="mr-2">mdi-check-circle</v-icon> Choose exactly when your messages go out — weekdays only, business hours, or any custom schedule. 
                            </v-list-item>


                        </v-list>

                    </div>
                </v-col>
                <v-col cols="12" md="5" class="px-10">
                    <h1 class="mb-5">Built for Compliance and Scalability</h1>
                    <div>
                        Customise the distribution of your message.
                        <v-list>
                            <v-list-item class="mb-3">
                                <v-icon color="green" class="mr-2">mdi-check-circle</v-icon> <div><b>Automated Opt-Out Management:</b> Responses like “STOP” are instantly recorded, keeping future campaigns compliant.</div>
                            </v-list-item>
                            <v-list-item class="mb-3">
                                <v-icon color="green" class="mr-2">mdi-check-circle</v-icon> <div><b>High-Volume Infrastructure:</b> Built to handle millions of sends without issue.</div>
                            </v-list-item>
                            <v-list-item class="mb-3">
                                <v-icon color="green" class="mr-2">mdi-check-circle</v-icon> <div><b>Enterprise-Grade Reporting:</b> Track delivery, open rates, and engagement in real-time.</div>
                            </v-list-item>
                            <v-list-item class="mb-3">
                                <v-icon color="green" class="mr-2">mdi-check-circle</v-icon> <div><b> Custom Send Rates:</b> Control delivery speed to suit your operations — send at 10,000/hour, 100,000/hour, or scale up to millions per day.</div>
                            </v-list-item>

                        </v-list>
                        
                    </div>
                </v-col>
                <v-col cols="1">
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'CampaignsFeatures',
}
</script>

<style lang="scss">

</style>